import { render, staticRenderFns } from "./trial.vue?vue&type=template&id=23cea9b9&scoped=true&"
import script from "./trial.vue?vue&type=script&lang=js&"
export * from "./trial.vue?vue&type=script&lang=js&"
import style0 from "./trial.vue?vue&type=style&index=0&id=23cea9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cea9b9",
  null
  
)

component.options.__file = "trial.vue"
export default component.exports